import React, { useState } from "react";
import "./Header.css";

export default function Header() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <header className="header">

        {/* Burger Button */}
        <button
          className={`burger ${open ? "open" : ""}`}
          onClick={() => setOpen(!open)}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        {/* Logo Only on Right */}
        <img src="/logo.png" className="header-logo" alt="Logo" />
      </header>

      {/* Overlay */}
      <div
        className={`overlay1 ${open ? "show" : ""}`}
        onClick={() => setOpen(false)}
      ></div>

      {/* Sidebar */}
      <nav className={`sidebar ${open ? "open" : ""}`}>
      <button className="close-btn" onClick={() => setOpen(false)}>
    ×
  </button>
        <ul className="menu-list">
          <li><a href="/">Գլխավոր</a></li>
          <li><a href="/menu">Մենյու</a></li>
          <li><a href="/about">Մեր մասին</a></li>
          <li><a href="/contact">Կապ</a></li>
        </ul>

        {/* Social icons inside sidebar */}
        <div className="sidebar-socials">
        <a
  href="https://www.instagram.com/pascali.evn/"
  target="_blank"
  rel="noopener noreferrer"
>
  <img src="/icons/instagram.png" alt="Instagram" />
</a>

<a
  href="https://www.facebook.com/profile.php?id=61575009515586"
  target="_blank"
  rel="noopener noreferrer"
>
  <img src="/icons/facebook.png" alt="Facebook" />
</a>

        </div>
      </nav>
    </>
  );
}
